import { useCallback, useEffect, useState } from "react";
import { createEmptyChangeContext, getChangeContext } from "../services/change_context_service";

export default function useChangeContext(changeId) {
	const [context, setContext] = useState(createEmptyChangeContext());
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");

	const refresh = useCallback(async () => {
		if (!changeId) {
			setContext(createEmptyChangeContext());
			setError("");
			return;
		}

		setLoading(true);
		setError("");

		try {
			const nextContext = await getChangeContext(changeId);
			setContext(nextContext);
		} catch (nextError) {
			setError(nextError?.message || "Failed to load change context");
			setContext(createEmptyChangeContext());
		} finally {
			setLoading(false);
		}
	}, [changeId]);

	useEffect(() => {
		let isCancelled = false;

		async function loadContext() {
			if (!changeId) {
				setContext(createEmptyChangeContext());
				setError("");
				return;
			}

			setLoading(true);
			setError("");

			try {
				const nextContext = await getChangeContext(changeId);
				if (isCancelled) {
					return;
				}
				setContext(nextContext);
			} catch (nextError) {
				if (isCancelled) {
					return;
				}
				setError(nextError?.message || "Failed to load change context");
				setContext(createEmptyChangeContext());
			} finally {
				if (!isCancelled) {
					setLoading(false);
				}
			}
		}

		loadContext();

		return () => {
			isCancelled = true;
		};
	}, [changeId]);

	return {
		context,
		loading,
		error,
		refresh,
	};
}
